import lista from './Indicativos.json'
import axios from "axios";

export const envioNotificaciones= async (entidad) => {


    let data = JSON.stringify({
        "nombre": entidad.nombre,
        "negocio": entidad.negocio,
        "pais": entidad.pais,
        "correo": entidad.correo,
        "mensaje": entidad.mensaje,
        "indicador": obtenerIndicativo(entidad.pais),
        "numero": entidad.celular
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/fb3dd10f-bb9f-4414-abd9-0b2dc8a4215a',
      //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/fb3dd10f-bb9f-4414-abd9-0b2dc8a4215a', //test
        headers: {
            'Content-Type': 'application/json'
        },
        data : data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });



}

const obtenerIndicativo = (pais) =>{

    let arr = lista.filter((valor) => valor.nameES === pais)
    return arr[0].phoneCode.toString()

}